import { type RouteRecordRaw } from 'vue-router'

export const billingRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/BillingPayoutsView.vue'),
        meta: {
          billingRoute: true,
          title: 'payouts',
        },
        name: 'brand.billing.payouts',
        path: 'payouts',
      },
      {
        component: async () => import('../views/BillingHomeView.vue'),
        meta: {
          billingRoute: true,
          title: 'invoices',
        },
        name: 'brand.billing.invoices',
        path: 'invoices',
      },
      {
        component: async () => import('../views/BillingDetailView.vue'),
        meta: {
          billingRoute: true,
          title: 'invoices',
        },
        name: 'brand.billing.invoices.detail',
        path: 'invoices/:invoiceId',
      },
      {
        component: async () => import('../views/BillingTransactionsView.vue'),
        meta: {
          billingRoute: true,
          title: 'transactions',
        },
        name: 'brand.billing.transactions',
        path: 'transactions',
      },
      {
        component: async () => import('../views/TransactionDetailView.vue'),
        meta: {
          billingRoute: true,
          title: 'transactions',
        },
        name: 'brand.billing.transactions.detail',
        path: 'transactions/:transactionId',
      },
      {
        component: async () => import('../views/BillingPaymentMethodView.vue'),
        meta: {
          billingRoute: true,
          title: 'subscriptions',
        },
        name: 'brand.billing.methods',
        path: 'methods',
      },
      {
        component: async () => import('../views/BillingAccountView.vue'),
        meta: {
          billingRoute: true,
          title: 'account',
        },
        name: 'brand.billing.account',
        path: 'account',
      },
      {
        component: async () => import('../views/BillingDisputesView.vue'),
        meta: {
          billingRoute: true,
          title: 'disputes',
        },
        name: 'brand.billing.disputes',
        path: 'disputes',
      },
    ],
    component: {
      name: 'BillingRouterView',
      template: '<router-view></router-view>',
    },
    name: 'brand.billing',
    path: 'billing',
    redirect: { name: 'brand.billing.payouts' },
  },
]
